import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

// Components
import ThemeMenuOne from '../../../components/header/ThemeMenuOne'
import PageTitle from '../../../components/page-title/PageTitle'
import FAQ from '../../../components/faq/FAQ'
import NewsletterOne from '../../../components/call-to-action/NewsletterOne'
import FooterOne from '../../../components/footer/FooterOne'

const Faq = () => {
  return (
    <Fragment>
      <div className="main-page-wrapper">
        {/* Helmet start */}
        <Helmet>
          <title>FAQ || Techy – IT Solution & Web Security React Template</title>
        </Helmet>
        {/* Helmet end */}

        <ThemeMenuOne />
        <PageTitle title="FAQ" />

        {/*faq start*/}
        <div className="faq-que-list pt-150 pb-115 pt-lg-60 pb-lg-60">
          <div className="container">
            <div className="row gx-4 gx-xxl-5">
              <div className="col-md-6">
                <FAQ />
              </div>
              <div className="col-md-6">
                <FAQ />
              </div>
            </div>
            <div className="row gx-4 gx-xxl-5 accordion-style-two justify-content-center mt-70">
              <div className="col-lg-10 col-md-10">
                <FAQ />
              </div>
            </div>
            <div className="row gx-4 gx-xxl-5">
              <div className="col-lg-12 text-center mb-25">
                <Link className="theme_btn" to="/faq">Add Your Questions</Link>
              </div>
            </div>
          </div>
        </div>
        {/*faq end*/}

        <NewsletterOne />
        <FooterOne />
      </div>
    </Fragment>
  )
}

export default Faq
